import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

// Renders every page of the PDF at `url` to a PNG data URL so it can be
// printed as plain images inside a hidden iframe. Mobile browsers' built-in
// PDF viewer ignores contentWindow.print(), so printing the raw PDF directly
// doesn't work there — rendering to images sidesteps that viewer entirely.
export async function renderPdfToImages(url, scale = 1.5) {
  const pdf = await pdfjsLib.getDocument(url).promise;
  const images = [];
  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const ctx = canvas.getContext("2d");
    await page.render({ canvasContext: ctx, viewport }).promise;
    images.push(canvas.toDataURL("image/png"));
  }
  return images;
}
